'use client'

import { useEffect } from 'react'

import { useHeaderButtons } from '@/components/providers/HeaderButtonsProvider'
import { usePage } from '@/components/providers/PageProvider'
import { getFilterCount } from '@/utils/routeUtil'

export const ButtonFilters = () => {
  const { setFiltersCount, setIsActive } = useHeaderButtons()
  const { page } = usePage()

  const route = page?.route
  const count = getFilterCount(route)

  useEffect(() => {
    setFiltersCount(count)
    setIsActive(true)

    return () => {
      setFiltersCount(0)
      setIsActive(false)
    }
  }, [count, setFiltersCount, setIsActive])

  return null
}
